import type { PremiumTrialDigestDataQuery as PremiumTrialDigestDataQueryType } from './__types__/PremiumTrialDigestDataQuery';

export const getPercentageUsage = (
	queryData: Partial<PremiumTrialDigestDataQueryType> | undefined,
): number => {
	const totalLicences = queryData?.license?.licenseConsumingUserCount;
	const totalPremiumUsedUsers = queryData?.premiumFeaturesUserCount?.user;

	if (!totalLicences || !totalPremiumUsedUsers) return 0;

	const totalUsagePercentage = totalPremiumUsedUsers / totalLicences;

	return parseFloat(totalUsagePercentage.toFixed(2));
};
